// extracted by mini-css-extract-plugin
export default {"list":"order-page-info_list__drevn"};